import { ColaboratorForm } from '@/components/forms/colaboratorForm/colaboratorForm';
import TableView from '@/components/colaborators/TableView';
import { CommandInput, Command } from '@/components/shadcn/ui/command';
import { Colaborator } from '@/entities/colaborator';
import { useColaborator } from '@/hook/useColaborator';
import React, { useEffect, useState } from 'react';

// interface ColaboratorFormData {
//     nome: string;
//     descricao: string; 
//     valor: string;
//     codprod: string;
//     comissao: string;
//   }
  
const ColaboradorPage = () => {
  const [ColaboratorsPage, setColaborators] = useState<Colaborator[]>([]);
  const { ColaboratorsUse, idToEdit, editColaborator, getAllColaborators2, setIdToEdit, open, updateColaborator, createColaborator, setEditColaborator, setOpen, selectedColaborator, setSelectedColaborator} = useColaborator();
  const companyId = Number(localStorage.getItem("companyId"));
  useEffect(()=>{
    setColaborators(ColaboratorsUse);
  },[ColaboratorsUse]);

  const handleColaboratorSubmit = async (data: any) => {
    const dataColaborator = {
      name: data.nome,
      email: data.email,
      companyId: companyId,
      cellPhone: data.cellPhone,
      whatsapp: data.whatsapp,
    };
  
    try {
      const ColaboratorCreated = await createColaborator(dataColaborator);
      if (ColaboratorCreated) {
        setColaborators([...ColaboratorsPage, ColaboratorCreated]);
      } else {
        console.error('Erro: Os dados criado é nulo.');
      }
    } catch (error) {
      console.error('Erro ao Cadastrar Colaborador:', error);
    }
  };

  const handleColaboratorUpdateSubmit = async (data: any) => {
    const dataColaborator = {
      name: data.nome,
      email: data.email,
      companyId: companyId,
      cellPhone: data.phone,
      whatsapp: data.whatsapp,
      isAdmin: data.isAdmin,
    };

    try {
      await updateColaborator(idToEdit, dataColaborator);
      
    } catch (error) {
      console.error('Erro ao cadastrar Colaborador:', error);
    }
  };
  
  const alterOpen = (value:boolean) =>{
    setOpen(value);
  };

  const setColaborator = (data:any | undefined) => {
    const copyData = {...data};
    setSelectedColaborator(copyData);
  };

  const isEdit = (value: boolean) => {
    setEditColaborator(value);
  };

  const setId = (id: number) =>{
    setIdToEdit(id);
  };

  const handleColaboratorDelete = (index: number) => {
    const listColaborators = [...ColaboratorsPage];
    listColaborators.splice(index, 1);
    setColaborators(listColaborators);
  };

  return (
    <div className='min-h-screen bg-indigo-200 p-8'>
      <div className='min-h-100 flex flex-col overflow bg-white rounded-md py-4 mx-8 mb-4 '>   
        <div className='flex m-2 justify-between items-center pr-2'>
          <h1 className='m-4 text-md font-medium'>Colaboradores</h1>
          <div className='flex gap-6'>
            <ColaboratorForm  onColaboratorSubmit={editColaborator ? handleColaboratorUpdateSubmit : handleColaboratorSubmit}  isOpen={open} setOpen={alterOpen} setEdit={isEdit} data2={editColaborator ? selectedColaborator : undefined } editing ={editColaborator} setSelectedColaborator = {setColaborator}/>
            <Command className='flex items-center rounded-lg border-2 p-1 gap-1'>
              <CommandInput placeholder="Pesquisar..."/>
            </Command>
          </div>
        </div>
        <div>
          <TableView
            data={ColaboratorsPage}
            onColaboratorDelete={handleColaboratorDelete}
            open = {open} 
            setOpen={alterOpen}
            setSelectedColaborator={setColaborator}
            setEdit={isEdit}
            setIdToEdit = {setId}
          />
        </div>
      </div>
    </div>
  );
};

export default ColaboradorPage;
